export { default as PuntoVenta} from './Punto';
export { default as PagoVenta } from './Pago';
export { default as DetalleVenta } from './Detalle_venta';
export { default as DetalleCuenta } from './Cuenta';
